import ReceiptView from "@/views/public/order/ReceiptView.vue";

export default {
  path: "/receipt",
  name: "receipt",
  component: ReceiptView
};
